package com.veldekar.pages.spells

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.`data`.add
import com.varabyte.kobweb.core.`init`.InitRoute
import com.varabyte.kobweb.core.`init`.InitRouteContext
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.CloseIcon
import com.varabyte.kobweb.silk.style.toModifier
import com.veldekar.components.layouts.PageLayout
import com.veldekar.components.layouts.PageLayoutData
import com.veldekar.components.srd.SpellCardContent
import com.veldekar.components.srd.spells.MagnificentMansionDescription
import com.veldekar.components.srd.spells.MagnificentMansionMetadata
import org.jetbrains.compose.web.css.cssRem

@InitRoute
public fun initMagnificentMansionPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(
        title = "Magnificent Mansion",
        ogTitle = "Magnificent Mansion",
        ogDescription = "The heroes now have a place to crash after a long day of adventuring, and it's all thanks to Dirk's Magnificent Mansion spell.",
        includeSrdAttribution = true,
        isModal = true,
        showModalCard = false
    ))
}

@Page(routeOverride = "/spell-magnificent-mansion")
@Composable
public fun MagnificentMansionPage() {
    val ctx = rememberPageContext()
    PageLayout(ctx) {
        Column(Modifier.fillMaxWidth().padding(2.cssRem).gap(1.cssRem)) {
            SpellCardContent(
                name = "Magnificent Mansion",
                subtitle = "7th-level Conjuration",
                veldekar = "The heroes now have a place to crash after a long day of adventuring, and it's all thanks to Dirk's Magnificent Mansion spell.",
                image = "",
                headerExtra = {
                    Row(Modifier.cursor(Cursor.Pointer).onClick { ctx.router.navigateTo("/spells") }, verticalAlignment = Alignment.CenterVertically) {
                        CloseIcon(Modifier.fontSize(1.5.cssRem))
                    }
                }
                ,
                metadata = { MagnificentMansionMetadata() },
                content = { MagnificentMansionDescription() }
            )
        }
    }
}
